import { isContentfulString } from '@philips-internal/oswald-ui-utils';
import { HttpHeader } from '../http-service-constants.js';
function isBlobBody(body) {
    return body instanceof Blob;
}
function isFormDataBody(body) {
    return body instanceof FormData;
}
function isStringBody(body) {
    if (!isContentfulString(body)) {
        return false;
    }
    try {
        JSON.parse(body);
    }
    catch {
        return true;
    }
    return false;
}
function isURLSearchParamsBody(body) {
    return body instanceof URLSearchParams;
}
function mapRequestBody(body) {
    const skipStringify = body
        && (isBlobBody(body)
            || isFormDataBody(body)
            || isStringBody(body)
            || isURLSearchParamsBody(body));
    if (skipStringify) {
        return body;
    }
    return JSON.stringify(body);
}
function mapRequestHeaders(options) {
    const headers = new Headers({ ...options.headers });
    if (isFormDataBody(options.body)) {
        headers.delete(HttpHeader.CONTENT_TYPE);
    }
    return headers;
}
export { mapRequestBody, mapRequestHeaders, };
//# sourceMappingURL=http-service-request-mappers.js.map